import { oaApi } from 'api/axios'
import { mdl21Urls } from './mdl21.urls'

/**
 * Realiza la asignación de sucursal para entrega a domicilio (delivery)
 * @param {Object} payload - Datos requeridos por el endpoint OA delivery
 * @returns {Promise<Object>} Respuesta del sistema OA
 */

export const orderAllocationDelivery = async payload => {
  const { data } = await oaApi.post(mdl21Urls.inventoryDelivery, payload)
  return data
}
